/* global window:false*/
import React from 'react';
import PropTypes from 'prop-types';
import container from '../containers/location';

class LocationMapSatelliteEmbed extends React.PureComponent {
	componentWillMount() {
		if (!this.props.location && this.props.getLocation) {
			this.props.getLocation();
		}
	}

	render () {
		const {
			location,
			zoom,
			width,
			height,
		} = this.props;

		if (!location || !location.latitude || !location.longitude) {
			return null;
		}

		const src = [
			"https://www.google.com/maps/embed/v1/view?key=AIzaSyBoFAhnEojgTGTAk74ZxwMFO75sve5B5V4",
			`center=${location.latitude},${location.longitude}`,
			`zoom=${zoom}`,
			"maptype=satellite"
		].join("&");

		return (
			<iframe
				src={src}
				width={width}
				height={height}
			/>
		);
	}
}

LocationMapSatelliteEmbed.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	location : PropTypes.object,
	getLocation : PropTypes.func,
	zoom : PropTypes.number,
};

LocationMapSatelliteEmbed.defaultProps = {
	location : null,
	zoom : 18,
	width: 0,
	height: 0,
};

export default container(LocationMapSatelliteEmbed);
